import { useState } from "react";
import { useLanguage } from "@/lib/LanguageContext";

export default function Faq() {
    const [open, setOpen] = useState(null);
    const { t } = useLanguage();
    return (
        <section id="faq" className="ps-section ps-relative-z" data-testid="faq-section">
            <div className="ps-container">
                <div className="ps-section-head">
                    <h2 className="ps-display ps-section-title" data-split data-split-scroll data-testid="faq-title"
                        dangerouslySetInnerHTML={{ __html: t.faq.title }} />
                </div>

                <div className="ps-faqs" data-testid="faq-list">
                    {t.faq.items.map((f, i) => {
                        const isOpen = open === i;
                        return (
                            <button
                                key={i}
                                type="button"
                                className={`ps-faq ${isOpen ? "is-open" : ""}`}
                                onClick={() => setOpen(isOpen ? null : i)}
                                data-testid={`faq-item-${i + 1}`}
                                aria-expanded={isOpen}
                            >
                                <div className="ps-faq-summary">
                                    <span className="ps-faq-q">{f.q}</span>
                                    <span className="ps-faq-toggle" aria-hidden="true" />
                                </div>
                                <div className="ps-faq-answer" style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}>
                                    <div><p>{f.a}</p></div>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
